import { ModelDef } from '../../CORE/src/common/$models/ModelDef'
import {
  formatHiddenPagesForDisplay,
  SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_SELECTIONS,
} from '../services/YhcServiceLevelList/serviceLevelNoticePageUtils'

/**
 * サービスレベル検索ページに表示するお知らせ
 * - 公開 Web: 有効期間・非表示対象ページ・モーダル期間でフィルタして表示
 * - 管理画面: CRUD
 */
export const yhc_service_level_notices: ModelDef = {
  tableName: 'yhc_service_level_notices',
  tableLabel: 'お知らせ',
  primaryKeyColType: 'UUID',
  defaultSort: { key: 'createdAt', order: 'desc' },
  columns: {
    title: {
      type: 'STRING',
      label: '管理用タイトル',
    },
    display_date: {
      type: 'DATEONLY',
      label: '表示日',
      validate: { notEmpty: true },
    },
    hidden_pages: {
      type: 'MULTISELECT',
      label: '非表示対象のページ',
      inputHelpText: '選択したページではこのお知らせをリスト・モーダルともに非表示にします',
      selections: () => SERVICE_LEVEL_NOTICE_HIDDEN_PAGES_SELECTIONS,
      customLabel: (value) => formatHiddenPagesForDisplay(value),
      strictSelections: true,
    },
    enabled_from: {
      type: 'DATETIME',
      label: '有効期間 開始',
      validate: { notEmpty: true },
    },
    disabled_at: {
      type: 'DATETIME',
      label: '有効期間 終了',
      validate: { notEmpty: true },
    },
    modal_start_datetime: {
      type: 'DATETIME',
      label: 'モーダル表示 開始',
      inputHelpText: 'サービスレベル検索ページアクセス時に強制表示する開始日付です',
    },
    modal_end_datetime: {
      type: 'DATETIME',
      label: 'モーダル表示 終了',
      inputHelpText: '強制表示の終了日付です',
    },
    is_new: {
      type: 'BOOLEAN',
      label: '新着フラグ',
      inputHelpText: '新着表示したい場合、チェックを入れてください',
    },
    content: {
      type: 'RICHTEXT',
      label: 'お知らせ本文',
      validate: { notEmpty: true },
      width: { xs: 48 },
    },
    attachments: {
      type: 'ARRAY_OF_OBJECT',
      label: '添付ファイル',
      width: { xs: 48 },
      columns: {
        file_path: {
          type: 'FILEUPLOAD',
          label: 'ファイル',
          validate: { notEmpty: true },
          inputAttrs: {
            filePathPrefix: 'yhc/service-level-notices/',
          },
        },
        display_name: {
          type: 'STRING',
          label: '表示ファイル名',
          inputHelpText: '未入力の場合はアップロードしたファイル名をリンク表示します',
        },
      },
    },
    tooltip_target_text: {
      type: 'STRING',
      label: 'ツールチップを表示する対象テキスト',
      inputHelpText: '本文内のこのテキストにカーソルを載せるとツールチップが表示されます',
    },
    tooltip_content: {
      type: 'RICHTEXT',
      label: 'ツールチップに表示する詳細内容',
      inputHelpText: 'ツールチップに表示する詳細説明を入力してください',
      width: { xs: 48 },
    },
  },
}
